export default __webpack_public_path__ + "static/media/play-button.b50e040f.svg";